<app-order-detail
  [getOrder]="getOrder"
  [changeOrderState]="changeOrderState"
>
</app-order-detail>
